// ============================================================================
// FILE: src/modules/ppe/pages/masters/sku-attributes/skuAttributeService.js
// ============================================================================

import axiosClient from "../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/sku-attributes";

const skuAttributeService = {

  // ============================================================
  // GET ATTRIBUTES (BY ENTITY)
  // ============================================================
  getAttributes: async (entityType) => {
    try {
      const response = await axiosClient.get(`${BASE_URL}?entity=${entityType}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching attributes", error);
      return { success: false, message: "Failed to fetch attributes" };
    }
  },

  getAttributeValues: async (attributeId) => {
    try {
      const res = await axiosClient.get(
        `/api/ppe/sku-attributes/${attributeId}/values`
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return { success: false };
    }
  },
  // ============================================================
// GET ATTRIBUTES FOR ENTITY
// ============================================================
getAttributesForEntity: async (entityType) => {
  try {
    const res = await axiosClient.get(
      `/api/ppe/sku-attributes/entity/${entityType}`
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching attributes for entity", error);
    return { success: false };
  }
},

  // ============================================================
  // CREATE ATTRIBUTE
  // ============================================================
  createAttribute: async (payload) => {
    try {
      const response = await axiosClient.post(BASE_URL, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating attribute", error);
      return { success: false, message: "Failed to create attribute" };
    }
  },

  // ============================================================
  // ADD VALUE (LIST TYPE)
  // ============================================================
  addAttributeValue: async (attributeId, payload) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/${attributeId}/values`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error adding attribute value", error);
      return { success: false, message: "Failed to add value" };
    }
  },
  
////////
// ============================================================
// MAP ATTRIBUTES
// ============================================================
mapAttributes: async (payload) => {
  try {
    const res = await axiosClient.post(
      `${BASE_URL}/map`,
      payload
    );
    return res.data;
  } catch (error) {
    console.error("Error mapping attributes", error);
    return { success: false, message: "Failed to map attributes" };
  }
},

// ============================================================
// GET MAPPED ATTRIBUTES
// ============================================================
getMappedAttributes: async (entityType, entityId) => {
  try {
    console.log("🔥 CALLING MATERIAL API", entityType, entityId);
    const res = await axiosClient.get(
      `${BASE_URL}/material/${entityType}/${entityId}`
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching mapped attributes", error);
    return { success: false };
  }
},

///////
  

  // ============================================================
  // ASSIGN APPLICABILITY
  // ============================================================
  assignApplicability: async (attributeId, payload) => {
    try {
      const response = await axiosClient.post(
        `${BASE_URL}/${attributeId}/applicability`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning applicability", error);
      return { success: false, message: "Failed to assign applicability" };
    }
  }

};

export default skuAttributeService;